"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = exports.camelToKebab = void 0;
const camelToKebab = (s) => {
    return s
        .replace(/([a-z]+)([A-Z0-9]+)/g, (_, p1, p2) => 
    // Keep values like x1 - as is
    p1.length === 1 && /^[0-9]+$/.test(p2) ? `${p1}${p2}` : `${p1}-${p2}`)
        .toLowerCase();
};
exports.camelToKebab = camelToKebab;
const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1);
};
exports.capitalize = capitalize;
